import {ADD_MESSAGE, HIDE_SIDEBAR, REMOVE_MESSAGE, SHOW_SIDEBAR} from "../constants/action-types";

export const addMessage = message => ({type: ADD_MESSAGE, payload: message});
export const removeMessage = message => ({type: REMOVE_MESSAGE, payload: message});

export const showSidebar = () => ({type: SHOW_SIDEBAR});
export const hideSidebar = () => ({type: HIDE_SIDEBAR});